import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWebSecState } from "models/Slices/webSecuritySlice.model";
import { webSecurityAsync } from "redux/actions/WebSecurity.action";
import { IWebSecurityResponse } from "models/WebSecurity/webSecurity.model";

const initialState: IWebSecState = {
  mbb: "",
  webSec: null,
  loading: false,
  error: "",
  success: false,
};

export const webSecuritySlice = createSlice({
  name: "webSecurity",
  initialState,
  reducers: {
    setMBB: (state, action: PayloadAction<string>) => {
      state.mbb = action.payload;
    },
    ResetWebSecurityError: (state) => {
      state.error = "";
    },
    ResetWebSecurity: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(webSecurityAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        webSecurityAsync.fulfilled,
        (state, action: PayloadAction<IWebSecurityResponse>) => {
          state.loading = false;
          state.webSec = action.payload;
          state.success = state.webSec?.DialogBoxes.length === 0 ? true : false;
        }
      )
      .addCase(webSecurityAsync.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
        state.success = false;
      });
  },
});

export const {
  setMBB,
  ResetWebSecurityError,
  ResetWebSecurity,
} = webSecuritySlice.actions;

export default webSecuritySlice.reducer;
